const schema = () => ({
  type: 'object',
  required: [],
  properties: {
    title: {
      type: 'string',
      title: 'عنوان',
    },
    manager_id: {
      type: 'string',
      title: 'مدیر',
    },
    is_active: {
      type: 'number',
      title: 'فعالیت',
      oneOf: [
        { const: 1, title: 'فعال' },
        { const: 0, title: 'غیرفعال' },
      ],
    },
  },
});

export default schema;
